import * as SwitchPrimitive from "@radix-ui/react-switch";
import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";

export function Switch({ className, ...props }: ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        "group relative inline-flex h-11 w-14 shrink-0 items-center rounded-full border border-transparent bg-transparent disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <span className="pointer-events-none absolute left-1 top-2 h-7 w-12 rounded-full bg-muted-foreground/30 transition-colors group-data-[state=checked]:bg-primary" aria-hidden="true" />
      <SwitchPrimitive.Thumb className="pointer-events-none relative ml-1.5 block size-5.5 rounded-full bg-card shadow-sm transition-transform data-[state=checked]:translate-x-5" />
    </SwitchPrimitive.Root>
  );
}
